var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuShipsIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    stroke: "#435382",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 10.5L2.06063 15.7425C2.17193 16.1877 2.57191 16.5 3.03078 16.5H18.882C19.2607 16.5 19.607 16.286 19.7764 15.9472L22.5 10.5H20.25M0.75 10.5H20.25M0.75 10.5L2.25 7.5M20.25 10.5L19.0264 8.05279C18.857 7.714 18.5107 7.5 18.132 7.5H16.5M2.25 7.5H16.5M2.25 7.5V5.5C2.25 4.94772 2.69772 4.5 3.25 4.5H3.75M16.5 7.5L15.2764 5.05279C15.107 4.714 14.7607 4.5 14.382 4.5H10.125M10.125 4.5L9.56437 2.25746C9.45307 1.8123 9.05309 1.5 8.59422 1.5H8.40578C7.75521 1.5 7.27785 2.11139 7.43563 2.74254L7.875 4.5M10.125 4.5H7.875M7.875 4.5H6M6 4.5L5.43937 2.25746C5.32807 1.8123 4.92809 1.5 4.46922 1.5H4.28078C3.63021 1.5 3.15285 2.11139 3.31063 2.74254L3.75 4.5M6 4.5H3.75",
    stroke: "current",
    fill: "none",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuShipsIcon);
export default __webpack_public_path__ + "static/media/menu-ships-icon.a81d54e98e515e0da4347a1aa448af9e.svg";
export { ForwardRef as ReactComponent };